module.exports = __webpack_public_path__ + "media/images/icons/user-79802b561852e620931792b9f6698146.svg";